/**
 * Feature Flag 유틸리티.
 *
 * 환경 + 역할 기반으로 기능 활성화/비활성화를 관리한다.
 *
 * 사용법:
 *   import { FeatureUtil } from 'utils/FeatureUtil';
 *
 *   // 환경만 체크 (roles 제한 없는 기능)
 *   FeatureUtil.isEnabled('NHIS')
 *
 *   // 환경 + 역할 체크
 *   FeatureUtil.isEnabled('ADMIN_DASHBOARD', user.roles)
 *
 * 기능 추가:
 *   1. Feature 타입에 기능명 추가
 *   2. featureConfig에 규칙 추가
 */

type Environment = 'LOCAL' | 'PROD';

type Feature = 'NHIS';

interface FeatureRule {
  environments?: Environment[];  // 미지정 시 모든 환경 허용
  roles?: string[];              // 미지정 시 모든 역할 허용
}

// 검증 완료 → 전 환경 공개. featureConfig에서 제거 → 여기로 이동.
const graduatedFeatures: string[] = [
  'NHIS',  // 2026-04-01 전 환경 공개
];

const featureConfig: Partial<Record<Feature, FeatureRule>> = {
  // NHIS: {
  //   environments: ['LOCAL'],
  // },
};

function getCurrentEnvironment(): Environment {
  const env = process.env.REACT_APP_ENV || 'PROD';
  return env as Environment;
}

function isEnabled(feature: Feature, userRoles?: string[]): boolean {
  if (graduatedFeatures.includes(feature)) return true;

  const rule = featureConfig[feature];
  if (!rule) return true;

  const currentEnv = getCurrentEnvironment();
  if (rule.environments && !rule.environments.includes(currentEnv)) return false;
  if (!rule.roles) return true;
  if (!userRoles) return false;
  return rule.roles.some(role => userRoles.includes(role));
}

export type { Feature };

export const FeatureUtil = {
  isEnabled,
} as const;
